import { Typography } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SidePanel from '../SidePanel';
import SiderLayout from './SiderLayout';
import cx from '@vindr/utils/helpers/cx';

const { Title } = Typography;
interface ContentWrapperProps {
  children: React.ReactNode;
  title: string;
  headerAction?: React.ReactNode;
  filter?: React.ReactNode;
  updateFilter?: any;
  top?: string;
  filterPanelClassName?: string;
  filterPanelOverlayClassName?: string;
  bodyClassName?: string;
  headerClassName?: string;
}

const ContentWrapper = ({
  children,
  title,
  headerAction,
  filter,
  updateFilter,
  top,
  filterPanelClassName,
  filterPanelOverlayClassName,
  bodyClassName,
  headerClassName,
}: ContentWrapperProps) => {
  const { t } = useTranslation('Vindoc');
  const [isCollapsed, setIsCollapsed] = useState(window.innerWidth < 640);

  useEffect(() => {
    setIsCollapsed(true);
  }, [updateFilter]);

  return (
    <SiderLayout
      rightSidebar={
        filter ? (
          <SidePanel
            className={filterPanelClassName}
            collapsed={isCollapsed}
            side="right"
            sideOverlayClassName={filterPanelOverlayClassName}
            top={top}
            width={215}
            onChange={(val) => setIsCollapsed(val)}
          >
            <div className="m-2">{filter}</div>
          </SidePanel>
        ) : null
      }
    >
      <section
        className={cx(
          'flex h-full flex-col overflow-auto rounded-sm bg-background-light-3 p-4 dark:bg-background-dark-3',
          bodyClassName
        )}
      >
        <div
          className={cx(
            'flex min-h-12 shrink-0 flex-wrap items-center justify-between gap-2 border-b border-gray-800 pb-3 pt-0',
            headerClassName
          )}
        >
          <Title className="m-0 leading-none" level={4}>
            {t(title)}
          </Title>
          {headerAction}
        </div>
        {children}
      </section>
    </SiderLayout>
  );
};

export default ContentWrapper;
